// Últimos filtros buscados de un listado, por ruta, en sessionStorage.
//
// Por qué (Esteban, 2026-09-25): al filtrar Estudiantes, abrir el perfil o el
// estado de cuenta de un alumno y volver, el módulo se monta de cero y los
// filtros se perdían. Igual que paginaRecordada, aquí se guardan los filtros de
// la última búsqueda y el módulo los retoma al montarse. Solo valen para el
// mismo plantel: al cambiar de plantel o dar Limpiar se olvidan.

const clave = () => `wapp:filtros:${window.location.pathname}`

export function recordarFiltros(campusId: any, filtros: any): void
{
	try { sessionStorage.setItem(clave(), JSON.stringify({ campusId, filtros })) } catch { /* modo privado, etc. */ }
}

export function olvidarFiltros(): void
{
	try { sessionStorage.removeItem(clave()) } catch { /* nada */ }
}

/** Los filtros guardados para este plantel, o null si no hay. */
export function filtrosRecordados(campusId: any): any | null
{
	try
	{
		const guardado = JSON.parse(sessionStorage.getItem(clave()) || "null")
		return guardado && guardado.campusId === campusId && guardado.filtros ? guardado.filtros : null
	}
	catch { return null }
}
